/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import OtrosVehiculosComponent from "../components/vehiculos-detail/otros-vehiculos.component";
import LastNewsComponent from "../components/noticias/last_news.component";
import AllNewsComponent from "../components/noticias/all_news.component";
import {
  lastNewsforCategories,
  lastNewsforCategoriesOne,
  NewsOne,
  NewsOneForDate,
} from "../components/conexion/blogs.conexion";
import { useParams } from "react-router-dom";
import HeaderComponent from "../components/noticia_normal/header.component";
import ContenidoComponent from "../components/noticia_normal/contenido.component";
import DestacadosComponent from "../components/noticia_normal/destacados.component";
import OtrosVehiculosDinamicoComponent from "../components/vehiculos-detail/otros-vehiculos-dinamico.component";

/*eslint-disable */

const NoticiasNormalPage: React.FC = () => {
  const { category } = useParams<{ category?: string }>();
  const { news } = useParams<{ news?: string }>();
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [newsData, setNewsData]: any = useState([]);
  const [newsForCategories, setNewsForCategories]: any = useState([]);
  const [titleCategory, setTitleCategory]: any = useState([]);
  const [opportunities, setOpportunities]: any = useState([]);

  useEffect(() => {
    lastNewsforCategories().then(function (res: any) {
      const comunidadHyundaiPosts = res?.data?.data
        .flatMap((entry: any) => entry.Categories)
        .filter((categorie: any) => categorie.category_id === category)
        .flatMap((categorie: any) =>
          categorie.posts.map((post: any) => ({
            ...post,
            category: categorie.category, // ID del padre
            category_id: categorie.category_id, // category_id del padre
          }))
        );
      console.log(comunidadHyundaiPosts);
      setOpportunities(res?.data?.data[0].Opportunities);
      setNewsForCategories(comunidadHyundaiPosts);
    });
    NewsOne(category, news).then(function (res: any) {
      const filteredPost = res?.data?.data[0]?.posts?.find(
        (post: any) => post.slug === news
      );
      setTitleCategory(res?.data?.data[0]?.category);
      setNewsData(filteredPost);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Noticias Hyundai Colombia - Innovación, Lanzamientos y Actualidad
        </h1>

        <div className="home-page-mascara"></div>
        <HeaderComponent category={category} titleCategory={titleCategory} />
        <ContenidoComponent news={newsData} />
        <DestacadosComponent categories={newsForCategories} />
        <OtrosVehiculosDinamicoComponent opportunities={opportunities} />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default NoticiasNormalPage;
